import { render } from "./DeleteTeamForm.vue?vue&type=template&id=c1d27452"
import script from "./DeleteTeamForm.vue?vue&type=script&lang=js"
export * from "./DeleteTeamForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__